import { Cryptocurrency } from '#src/__generated__/globalTypes.ts';
import { useIntlContext } from '#src/contexts/intl/index.ts';
import { SOL_DECIMAL_PLACES, toLamport } from '#src/lib/lamport.ts';
import { ETH_DECIMAL_PLACES, toWei } from '#src/lib/wei.ts';

import { useMonetaryAmount } from './useMonetaryAmount.ts';

const MAXIMUM_FRACTION_DIGITS = {
  [Cryptocurrency.LAMPORT]: SOL_DECIMAL_PLACES,
  [Cryptocurrency.WEI]: ETH_DECIMAL_PLACES,
};

export const useCryptoAmount = (cryptocurrency: Cryptocurrency) => {
  const { lamport, wei } = useMonetaryAmount();
  const { formatLamport, formatWei, formatSol, formatEth } = useIntlContext();

  const {
    formatCryptoAmount,
    getCryptoAmount,
    toSubUnitAmount,
    formatCryptoMajor,
  } = (() => {
    switch (cryptocurrency) {
      case Cryptocurrency.LAMPORT:
        return {
          getCryptoAmount: lamport,
          formatCryptoAmount: formatLamport,
          formatCryptoMajor: formatSol,
          toSubUnitAmount: toLamport,
        };
      case Cryptocurrency.WEI:
      default:
        return {
          getCryptoAmount: wei,
          formatCryptoAmount: formatWei,
          formatCryptoMajor: formatEth,
          toSubUnitAmount: toWei,
        };
    }
  })();

  return {
    getCryptoAmount,
    formatCryptoAmount,
    toSubUnitAmount,
    formatCryptoMajor,
    maximumFractionDigits: MAXIMUM_FRACTION_DIGITS[cryptocurrency],
  };
};
